import { useBlockerDialog } from './use-blocker-dialog.js';
export function useBlockDirtyFormNavigate(formState, reset) {
    useBlockerDialog({
        disableBlock: !formState.isDirty,
        title: 'Unsaved Changes',
        content: 'You have unsaved changes. Are you sure you want to continue?',
        buttonContinueText: 'Discard Changes',
        onContinue: () => {
            reset();
            return true;
        },
    });
}
//# sourceMappingURL=use-block-dirty-form-navigate.js.map